import React from "react";
import styled from "styled-components";
import { ReactComponent as Search } from "./../../images/search.svg";
import { ChevronDown, ChevronUp } from "./ChevronDown";
import LoadingSpinner from "./LoadingSpinner";

const BrandSection = ({
  brands,
  selectedBrands,
  collapseBrands,
  setCollapseBrands,
  brandsCount,
  searchKey,
  setSearchKey,
  getAllBrands,
  sortBrands,
  onBrandToggle,
  getModelsForBrand,
  isLoadingForBrand,
  isCollapsedForBrand,
  toggleCollapseForBrand,
  selectedModels,
  onModelToggle,
  language,
  brandLoading,
  t,
}) => {
  const handleViewAllClick = () => {
    if (collapseBrands && brands.length === 7) {
      getAllBrands();
    } else {
      sortBrands(brands, selectedBrands);
    }

    if (!collapseBrands) {
      const element = document.getElementById("search-brand");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }
    }
    setCollapseBrands(!collapseBrands);
  };

  // Update the renderModels function in BrandSection.js

  const renderModels = (brandId) => {
    const models = getModelsForBrand(brandId);
    const isLoading = isLoadingForBrand(brandId);
    const isCollapsed = isCollapsedForBrand(brandId);

    if (isLoading) {
      return (
        <ModelsContainer>
          <LoadingContainer>
            <LoadingSpinner />
          </LoadingContainer>
        </ModelsContainer>
      );
    }

    if (models.length === 0) return null;

    const visibleModels = isCollapsed ? models.slice(0, 5) : models;

    return (
      <ModelsContainer>
        <ModelsHeader>
          <span>{t.carsFilter.models || "Models"}</span>
          {models.length > 5 && (
            <ToggleButton
              onClick={() => toggleCollapseForBrand(brandId)}
              type="button"
            >
              {isCollapsed ? (
                <>
                  <span>
                    {t.carsFilter.viewAll || "View All"} ({models.length})
                  </span>
                  <ChevronDown />
                </>
              ) : (
                <>
                  <span>{t.carsFilter.viewLess || "View Less"}</span>
                  <ChevronUp />
                </>
              )}
            </ToggleButton>
          )}
        </ModelsHeader>

        <ModelsList collapsed={isCollapsed}>
          {visibleModels.map((model) => {
            // Create a model object that includes the brand ID for proper filtering
            const modelWithBrand = {
              ...model,
              brand: brandId,
            };

            // FIXED: Check if this specific model is selected by comparing IDs
            const isModelSelected = [...selectedModels].some(
              (m) => m.id === model.id
            );

            return (
              <ModelItem key={model.id}>
                <label htmlFor={`model-${model.id}`}>
                  {language === "en" ? model.name : model.name_ar || model.name}
                </label>
                <input
                  id={`model-${model.id}`}
                  type="checkbox"
                  checked={isModelSelected}
                  onChange={() => {
                    onModelToggle(modelWithBrand);
                  }}
                />
              </ModelItem>
            );
          })}
        </ModelsList>
      </ModelsContainer>
    );
  };

  console.log("selectedBrands :  ", selectedBrands);

  return (
    <FilterSection className={language}>
      <div className="filter-title">{t.carsFilter.carBrand}</div>

      <SearchForm>
        <input
          value={searchKey}
          onChange={(e) => setSearchKey(e.target.value)}
          className="search-input"
          placeholder={t.carsFilter.searchforBrand}
          id="search-brand"
        />
        <div className="search-icon">
          <Search />
        </div>
      </SearchForm>

      <BrandsList id="brands-list" className={language}>
        {brandLoading
          ? Array.from({ length: 7 }).map((_, index) => (
              <BrandSkeleton key={index}>
                <div className="skeleton-logo" />
                <div className="skeleton-text" />
              </BrandSkeleton>
            ))
          : brands.slice(0, collapseBrands ? 7 : brands.length).map((brand) => (
              <BrandItem key={brand.id}>
                <div className="brand-main">
                  <div className="brand-info">
                    <img src={brand.logo} alt="brand" />
                    <label htmlFor={brand.id}>
                      {language === "en" ? brand.name : brand.name_ar}
                    </label>
                  </div>
                  <input
                    id={brand.id}
                    type="checkbox"
                    checked={[...selectedBrands].some(
                      (selectedBrand) => selectedBrand.id === brand.id
                    )}
                    onChange={() => {
                      onBrandToggle(brand);
                      console.log("Brand: ", brand);
                      console.log(
                        "selectedBrands.has(brand): ",
                        selectedBrands.has(brand.id)
                      );
                      console.log(
                        "selectedBrands.has(brand): ",
                        selectedBrands.has(brand)
                      );
                    }}
                  />
                </div>

                {selectedBrands.has(brand) && renderModels(brand.id)}
              </BrandItem>
            ))}
      </BrandsList>

      {brandsCount > 7 && !brandLoading && (
        <ViewAllButton onClick={handleViewAllClick}>
          {collapseBrands ? t.carsFilter.viewAllBrands : t.carsFilter.viewLess}
        </ViewAllButton>
      )}
    </FilterSection>
  );
};

const FilterSection = styled.div`
  margin-bottom: 10px;

  .filter-title {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 15px;
    padding-bottom: 8px;
    // border-bottom: 1px solid #e9ecef;
  }
  @media (max-width: 768px) {
    padding: 10px 15px;
  }
  #brands-list.ar {
    padding-right: 0px !important;
    padding-left: 15px !important;
  }
`;

const SearchForm = styled.div`
  position: relative;
  margin-bottom: 15px;

  .search-input {
    width: 100%;
    padding: 12px 45px 12px 15px;
    border: 2px solid #e9ecef;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s;

    &:focus {
      outline: none;
      border-color: #007bff;
    }

    &::placeholder {
      color: #6c757d;
    }
  }

  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const BrandsList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  // margin-bottom: 15px;
  padding-right: 15px;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #eeeeee;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #154cd6;
    border-radius: 3px;

    &:hover {
      background: rgba(21, 76, 214, 0.76);
    }
  }
`;

const BrandItem = styled.div`
  margin-bottom: 5px;
  // border: 1px solid #e9ecef;
  // border-radius: 8px;
  overflow: hidden;
  transition: box-shadow 0.2s;

  .brand-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;

    .brand-info {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      img {
        width: 25px;
        height: 25px;
        object-fit: contain;
        border-radius: 4px;
      }

      label {
        font-size: 14px;
        font-weight: 500;
        color: #2c3e50;
        cursor: pointer;
        flex: 1;
      }
    }

    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  }
`;

const ModelsContainer = styled.div`
  background: white;
  border-top: 1px solid #e9ecef;
`;

const ModelsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 5px;
  background: #f1f3f4;
  border-bottom: 1px solid #e9ecef;

  span {
    font-size: 13px;
    font-weight: 600;
    color: #495057;
  }
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #007bff;
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(0, 123, 255, 0.1);
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;

const ModelsList = styled.div`
  max-height: ${(props) => (props.collapsed ? "200px" : "300px")};
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #eeeeee;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #154cd6;
    border-radius: 3px;

    &:hover {
      background: rgba(21, 76, 214, 0.76);
    }
  }
`;

const ModelItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-bottom: 1px solid #f1f1f1;
  transition: background-color 0.2s;

  &:hover {
    background: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }

  label {
    font-size: 13px;
    color: #495057;
    cursor: pointer;
    flex: 1;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  color: #6c757d;

  span {
    font-size: 13px;
  }
`;

const ViewAllButton = styled.button`
  width: 100%;
  padding: 0;
  background: transparent;
  color: #154cd6;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: 0.2s;
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  margin-top: 15px;
`;

const BrandSkeleton = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  animation: pulse 1.5s infinite ease-in-out;

  .skeleton-logo {
    width: 25px;
    height: 25px;
    background: #e0e0e0;
    border-radius: 4px;
  }

  .skeleton-text {
    width: 120px;
    height: 14px;
    background: #e0e0e0;
    border-radius: 4px;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`;

export default BrandSection;
